import orderReducer from './orderReducer'
import raspaRecipeReducer from "./raspaRecipeReducer";
import raspaCycleReducer from "./raspaCycleReducer";
import stationReducer from "./stationReducer";
import serviceOrderStatisticsReducer from "./serviceOrderStatisticsReducer";
import filtersReducer from "./filtersReducer";
import raspaAlarmReducer from "./raspaAlarmReducer";
import AuthReducer from "./authReducer";
import roitreadCycleReducer from "./roitreadCycleReducer";
import autoclaveReducer from "./autoclaveReducer";
import tireReducer from "./tireReducer";
import i44Reducer from "./i4Reducer";
import v2Reducer from "./v2Reducer";
import {combineReducers} from "redux";
import {AUTH_LOGOUT} from "../actions/actionTypes";
import thotReducer from "./thotReducer";




const reducers = {
    auth: AuthReducer,
    ordemServicoReducer: orderReducer,
    tires: tireReducer,
    raspaRecipes: raspaRecipeReducer,
    raspaCycles: raspaCycleReducer,
    stations: stationReducer,
    serviceOrderStatistics: serviceOrderStatisticsReducer,
    filter: filtersReducer,
    raspaAlarm: raspaAlarmReducer,
    roitreadCycles: roitreadCycleReducer,
    autoclaves: autoclaveReducer,
    i4 : i44Reducer,
    thot: thotReducer,
    v2: v2Reducer
}


const allReducer = combineReducers(reducers);

const rootReducer = (state, action) => {

    if (action.type === AUTH_LOGOUT) {
        console.log('LOGOUT. Wiping out data.')
        localStorage.clear();
        return allReducer(undefined, action)
    }


        return allReducer(state, action);




};

export default rootReducer;
